/*
 * Closes the desktop menu's second line.
 *
 * The submenu used to hang off the bar as a panel, and a timer closed it once
 * the pointer left the header. It is now a line of the bar itself, which grows
 * to make room for it — so leaving it open is no longer a stale overlay but a
 * permanently taller header, and the pointer leaving is no longer a good reason
 * to collapse it under someone who is still reading.
 *
 * Dawn's own disclosure (assets/details-disclosure.js) only closes on focusout,
 * which never fires when the click lands on an unfocusable part of the page.
 * This fills that gap: a click outside the menu, Escape, or scrolling the page
 * away from the bar all put the bar back to its normal height.
 */
(function () {
  if (window.__headerDropdownCloseReady) return;
  window.__headerDropdownCloseReady = true;

  var MENU = '.custom-desktop-menu';
  var OPEN = '.custom-desktop-menu__details[open]';

  function closeAll() {
    document.querySelectorAll(OPEN).forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    if (!document.querySelector(OPEN)) return;
    // A click on the menu itself is the summary toggling, or a link being
    // followed; neither should be undone from here.
    if (event.target.closest && event.target.closest(MENU)) return;
    closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  // The header is sticky on scroll up. A grown bar riding along while the page
  // moves reads as something stuck, so scrolling settles it back.
  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking || !document.querySelector(OPEN)) return;
      ticking = true;
      requestAnimationFrame(function () {
        closeAll();
        ticking = false;
      });
    },
    { passive: true }
  );
})();
